import { generateClient, isCancelError, post } from "aws-amplify/api";

const client = generateClient();

export async function requestListBusinessProduct(dispatch, payload) {
  try {
    const { page, businessID, limit, nextTokens } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_PRODUCT",
      payload: { request: null, page },
    });

    let items = [];
    let nextToken = nextTokens || "start";

    const params = {
      businessID,
      limit,
      sortDirection: "DESC",
    };

    while (nextToken && items.length === 0) {
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: productsByBusinessCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_PRODUCT",
        payload: { request, page },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.productsByBusinessCreatedAt.items];
      nextToken = res.data.productsByBusinessCreatedAt.nextToken;
    }

    const nextPage = page + 1;

    dispatch({
      type: "LIST_BUSINESS_PRODUCT_SUCCESS",
      payload: {
        items,
        nextToken,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_PRODUCT_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_BUSINESS_PRODUCT_ERROR", error });
    }
  }
}

export async function requestGetBusinessProduct(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_BUSINESS_PRODUCT",
      payload: { request: null },
    });
    const { id } = payload;

    const request = client.graphql({
      query: getBusinessProduct,
      variables: { id },
    });
    dispatch({
      type: "REQUEST_GET_BUSINESS_PRODUCT",
      payload: { request },
    });

    const res = await request;

    if (!res.data.getBusinessProduct) {
      throw new Error("products.errors.notFound");
    }

    dispatch({
      type: "GET_BUSINESS_PRODUCT_SUCCESS",
      payload: { product: res.data.getBusinessProduct },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_PRODUCT_ERROR", error });
  }
}

export async function requestCreateBusinessProduct(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_PRODUCT",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: createBusinessProduct,
      variables: { input },
    });
    dispatch({ type: "REQUEST_CREATE_BUSINESS_PRODUCT", payload: { request } });

    const res = await request;
    const product = res.data.createBusinessProduct;
    dispatch({
      type: "SUCCESS_CREATE_BUSINESS_PRODUCT",
      payload: { product },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CANCEL_CREATE_BUSINESS_PRODUCT",
      });
    }
    dispatch({ type: "ERROR_CREATE_BUSINESS_PRODUCT", error });
  }
}

export async function requestUpdateBusinessProduct(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_PRODUCT",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: updateBusinessProduct,
      variables: { input },
    });
    dispatch({ type: "REQUEST_UPDATE_BUSINESS_PRODUCT", payload: { request } });

    const res = await request;

    const product = res.data.updateBusinessProduct;
    dispatch({
      type: "UPDATE_BUSINESS_PRODUCT_SUCCESS",
      payload: { product },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CANCEL_UPDATE_BUSINESS_PRODUCT",
      });
    }
    dispatch({ type: "ERROR_UPDATE_BUSINESS_PRODUCT", error });
  }
}

export async function requestDeleteBusinessProduct(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_BUSINESS_PRODUCT",
      payload: { request: null },
    });
    const { id } = payload;

    const request = client.graphql({
      query: deleteBusinessProduct,
      variables: { input: { id } },
    });
    dispatch({ type: "REQUEST_DELETE_BUSINESS_PRODUCT", payload: { request } });

    const res = await request;

    dispatch({
      type: "DELETE_BUSINESS_PRODUCT_SUCCESS",
      payload: { id: res.data.deleteBusinessProduct.id },
    });
  } catch (error) {
    dispatch({ type: "DELETE_BUSINESS_PRODUCT_ERROR", error });
  }
}

export async function requestListProductCategories(dispatch, payload) {
  try {
    const { page, businessID, limit, nextTokens } = payload;

    dispatch({
      type: "REQUEST_LIST_PRODUCT_CATEGORIES",
      payload: { request: null, page },
    });

    let items = [];
    let nextToken = nextTokens || "start";

    const params = {
      businessID,
      limit,
      sortDirection: "DESC",
    };

    while (nextToken && items.length === 0) {
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: productCategoriesByBusinessCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_PRODUCT_CATEGORIES",
        payload: { request, page },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [
        ...items,
        ...res.data.productCategoriesByBusinessCreatedAt.items,
      ];
      nextToken = res.data.productCategoriesByBusinessCreatedAt.nextToken;
    }

    const nextPage = page + 1;

    dispatch({
      type: "LIST_PRODUCT_CATEGORIES_SUCCESS",
      payload: {
        items,
        nextToken,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_PRODUCT_CATEGORIES_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_PRODUCT_CATEGORIES_ERROR", error });
    }
  }
}

export async function requestCreateProductCategory(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_PRODUCT_CATEGORY" });
    const { input } = payload;
    const res = await client.graphql({
      query: createBusinessProductCategory,
      variables: { input },
    });
    const category = res.data.createBusinessProductCategory;
    dispatch({
      type: "SUCCESS_CREATE_PRODUCT_CATEGORY",
      payload: { category },
    });
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_PRODUCT_CATEGORY", error });
  }
}

export async function requestUpdateProductCategory(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UPDATE_PRODUCT_CATEGORY" });
    const { input } = payload;
    const res = await client.graphql({
      query: updateBusinessProductCategory,
      variables: { input },
    });
    const category = res.data.updateBusinessProductCategory;
    dispatch({
      type: "SUCCESS_UPDATE_PRODUCT_CATEGORY",
      payload: { category },
    });
  } catch (error) {
    dispatch({ type: "ERROR_UPDATE_PRODUCT_CATEGORY", error });
  }
}

export async function requestAdjustProductStock(dispatch, payload) {
  try {
    const { id, type, quantity, note } = payload;

    dispatch({
      type: "REQUEST_ADJUST_PRODUCT_STOCK",
      payload: { request: null },
    });

    const request = post({
      apiName: "business",
      path: `/product/stock/${id}`,
      options: {
        body: {
          product_id: id,
          type,
          quantity,
          // `note` opsional: backend menyimpannya di baris ledger persediaan dan
          // Riwayat Stok menampilkannya. Kirim hanya bila terisi.
          ...(note && { note }),
        },
      },
    });
    dispatch({ type: "REQUEST_ADJUST_PRODUCT_STOCK", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();
    const ledger = res.data;

    dispatch({
      type: "ADJUST_PRODUCT_STOCK_SUCCESS",
      payload: { ledger },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "ADJUST_PRODUCT_STOCK_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "ADJUST_PRODUCT_STOCK_ERROR", error });
    }
  }
}

export async function requestInventoryWriteDown(dispatch, payload) {
  // PSAK 14 lower-of-cost-or-NRV write-down. Reuses the accounting `/invoice`
  // endpoint's action dispatcher; the backend posts the expense journal, lowers
  // the product's moving-average cost to the NRV, and records a WRITE_DOWN
  // ledger entry. Returns the result so the caller can branch on the no-op case
  // (writedownAmount === 0 when NRV >= average or there is no stock).
  const { productId, nrv } = payload;

  dispatch({ type: "REQUEST_INVENTORY_WRITEDOWN", payload: { request: null } });

  try {
    const request = post({
      apiName: "accounting",
      path: "/invoice",
      options: {
        body: {
          action: "inventory_writedown",
          product_id: productId,
          nrv,
        },
      },
    });
    dispatch({ type: "REQUEST_INVENTORY_WRITEDOWN", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();
    const result = res.data;

    dispatch({ type: "INVENTORY_WRITEDOWN_SUCCESS", payload: { result } });
    return result;
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "INVENTORY_WRITEDOWN_ERROR", error: null });
    } else {
      dispatch({ type: "INVENTORY_WRITEDOWN_ERROR", error });
    }
  }
}

export async function requestListInventoryLedger(dispatch, payload) {
  try {
    const {
      page,
      productID,
      limit,
      nextTokens,
      sortDirection = "DESC",
      filter,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_INVENTORY_LEDGER",
      payload: { request: null, page },
    });

    let items = [];
    let nextToken = nextTokens || "start";

    const params = {
      productID,
      limit,
      sortDirection,
      filter,
    };

    while (nextToken && items.length === 0) {
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: inventoryLedgerByProductCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_INVENTORY_LEDGER",
        payload: { request, page },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.inventoryLedgerByProductCreatedAt.items];
      nextToken = res.data.inventoryLedgerByProductCreatedAt.nextToken;
    }

    const nextPage = page + 1;

    dispatch({
      type: "LIST_INVENTORY_LEDGER_SUCCESS",
      payload: {
        items,
        nextToken,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_INVENTORY_LEDGER_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_INVENTORY_LEDGER_ERROR", error });
    }
  }
}

export async function clearAdjustProductStock(dispatch) {
  dispatch({ type: "CLEAR_ADJUST_PRODUCT_STOCK" });
}

export async function clearInventoryWriteDown(dispatch) {
  dispatch({ type: "CLEAR_INVENTORY_WRITEDOWN" });
}

export async function clearBusinessProduct(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_PRODUCT" });
}

export async function clearBusinessProductError(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_PRODUCT_ERROR" });
}

export async function clearProductCategory(dispatch) {
  dispatch({ type: "CLEAR_PRODUCT_CATEGORY" });
}

export async function clearInventoryLedger(dispatch) {
  dispatch({ type: "CLEAR_INVENTORY_LEDGER" });
}

const productsByBusinessCreatedAt = /* GraphQL */ `
  query ProductsByBusinessCreatedAt(
    $businessID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByBusinessCreatedAt(
      businessID: $businessID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        inUse
        categoryID
        category {
          id
          name
          createdAt
          updatedAt
        }
        name
        type
        price
        cost
        averageCost
        reference
        sellable
        purchasable
        taxBaseType
        taxBaseRate
        taxBasePercentage
        taxBaseFractionNumerator
        taxBaseFractionDenumerator
        currentStock
        stockLastUpdatedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getBusinessProduct = /* GraphQL */ `
  query GetBusinessProduct($id: ID!) {
    getBusinessProduct(id: $id) {
      id
      businessID
      categoryID
      category {
        id
        name
        createdAt
        updatedAt
      }
      name
      type
      price
      cost
      averageCost
      reference
      sellable
      purchasable
      taxBaseType
      taxBaseRate
      taxBasePercentage
      taxBaseFractionNumerator
      taxBaseFractionDenumerator
      currentStock
      stockLastUpdatedAt
      createdAt
      updatedAt
    }
  }
`;

const createBusinessProduct = /* GraphQL */ `
  mutation CreateBusinessProduct($input: CreateBusinessProductInput!) {
    createBusinessProduct(input: $input) {
      id
      businessID
      categoryID
      category {
        id
        name
        createdAt
        updatedAt
      }
      name
      type
      price
      cost
      averageCost
      reference
      sellable
      purchasable
      taxBaseType
      taxBaseRate
      taxBasePercentage
      taxBaseFractionNumerator
      taxBaseFractionDenumerator
      currentStock
      stockLastUpdatedAt
      createdAt
      updatedAt
    }
  }
`;

const updateBusinessProduct = /* GraphQL */ `
  mutation UpdateBusinessProduct($input: UpdateBusinessProductInput!) {
    updateBusinessProduct(input: $input) {
      id
      businessID
      categoryID
      category {
        id
        name
        createdAt
        updatedAt
      }
      name
      type
      price
      cost
      averageCost
      reference
      sellable
      purchasable
      taxBaseType
      taxBaseRate
      taxBasePercentage
      taxBaseFractionNumerator
      taxBaseFractionDenumerator
      currentStock
      stockLastUpdatedAt
      createdAt
      updatedAt
    }
  }
`;

const deleteBusinessProduct = /* GraphQL */ `
  mutation DeleteBusinessProduct($input: DeleteBusinessProductInput!) {
    deleteBusinessProduct(input: $input) {
      id
      businessID
      categoryID
      category {
        id
        name
        createdAt
        updatedAt
      }
      name
      type
      price
      cost
      averageCost
      reference
      sellable
      purchasable
      taxBaseType
      taxBaseRate
      taxBasePercentage
      taxBaseFractionNumerator
      taxBaseFractionDenumerator
      currentStock
      stockLastUpdatedAt
      createdAt
      updatedAt
    }
  }
`;

const productCategoriesByBusinessCreatedAt = /* GraphQL */ `
  query ProductCategoriesByBusinessCreatedAt(
    $businessID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productCategoriesByBusinessCreatedAt(
      businessID: $businessID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        name
        accountID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createBusinessProductCategory = /* GraphQL */ `
  mutation CreateBusinessProductCategory(
    $input: CreateBusinessProductCategoryInput!
  ) {
    createBusinessProductCategory(input: $input) {
      id
      businessID
      name
      accountID
      createdAt
      updatedAt
    }
  }
`;

const updateBusinessProductCategory = /* GraphQL */ `
  mutation UpdateBusinessProductCategory(
    $input: UpdateBusinessProductCategoryInput!
  ) {
    updateBusinessProductCategory(input: $input) {
      id
      businessID
      name
      accountID
      createdAt
      updatedAt
    }
  }
`;

const inventoryLedgerByProductCreatedAt = /* GraphQL */ `
  query InventoryLedgerByProductCreatedAt(
    $productID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductInventoryLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryLedgerByProductCreatedAt(
      productID: $productID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        business {
          id
          name
          type
          structure
          category
          taxCategory
          taxNumber
          yearRegistered
          address
          email
          phone
          alwaysSync
          createdAt
          updatedAt
        }
        productID
        product {
          id
          businessID
          name
          type
          price
          categoryID
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        type
        quantity
        quantityBefore
        quantityAfter
        sourceType
        sourceID
        reference
        note
        unitCost
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
